module.exports = __webpack_public_path__ + "img/Neon-Diver.4defb7a9.svg";